"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpenState = void 0;
const react_1 = require("react");
const useOpenState = ({ open, onOpen, onClose }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(open !== null && open !== void 0 ? open : false);
    const onOpenPopup = () => {
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        setIsOpen(true);
    };
    const onClosePopup = () => {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        setIsOpen(false);
    };
    (0, react_1.useEffect)(() => {
        if (typeof open === "boolean" && open !== isOpen) {
            setIsOpen(open);
        }
    }, [open]);
    return {
        isOpen,
        onOpenPopup,
        onClosePopup,
    };
};
exports.useOpenState = useOpenState;
//# sourceMappingURL=useOpenState.js.map